
import { useEffect, useState } from "react"
import url from "../api/url"
import { elToast } from "../functions/Alerta"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"
import { Link } from "react-router-dom"


export default function useListadoEmpleadosAdmin() {

    // variables
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const setIdEmpleadoVacaciones = useEmpleadoStore(state => state.setIdEmpleadoVacaciones)
    const [listaAdmin, setListaAdmin] = useState([])
    const [elementosFiltrados, setElementosFiltrados] = useState([])
    const [buscar, setBuscar] = useState('')
    const [cargando, setCargando] = useState(false)
    const [showForm, setShowForm] = useState(false)
    const [showHistorial, setShowHistorial] = useState(false)
    const { URL } = url()


    // func
    const traerDatos = () => {

        if (!objLogueado.email) {
            return
        }


        setCargando(true)


        fetch(URL, {
            method: 'post',
            body: JSON.stringify({ funcion: 'listarAdmin' })
        })
            .then(res => res.json())
            .then(e => {
                setListaAdmin(e)
                setElementosFiltrados(e)
            })
            .catch(a => {
                elToast('Hubo un error al cargar la lista de empleados', 'error')
            })
            .finally(() => setCargando(false))
    }

    // form modal
    const handleCloseForm = () => {
        setShowForm(false)
        setIdEmpleadoVacaciones(null)
    };
    const handleShowForm = id => {
        // console.log(id);

        setShowForm(true)
        setIdEmpleadoVacaciones(id)
    };

    // historial modal
    const handleCloseHistorial = () => {
        setShowHistorial(false)
    };
    const handleShowHistorial = () => setShowHistorial(true);



    // effect
    useEffect(() => {

        traerDatos()
        // eslint-disable-next-line
    }, [])


    useEffect(() => {
        let a = listaAdmin.filter(
            item => {
                const nombreNormalizado = item.nombre.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                const puestoNormalizado = item.puesto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                const buscarNormalizado = buscar.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                return (
                    nombreNormalizado.toLowerCase().includes(buscarNormalizado.toLowerCase())
                    || puestoNormalizado.toLowerCase().includes(buscarNormalizado.toLowerCase())
                )
            }
        );
        setElementosFiltrados(a)
        // eslint-disable-next-line
    }, [buscar])



    const columns = [
        {
            name: 'Nombre del empleado',
            sortable: true,
            selector: row => row.nombre,
        },
        {
            name: 'Puesto',
            sortable: true,
            selector: row => row.puesto,
        },
        {
            name: 'Opciones',
            selector: row => row.pk_empleado,
            cell: row => (
                <>
                    <Link to={`/admin/vacaciones/${row.pk_empleado}`}>
                        Asignar vacaciones
                    </Link>
                    {/* <Button variant="outline-primary" size="sm" onClick={() => handleShowForm(row.pk_empleado)}>
                        Asignar vacaciones
                    </Button>
                    &nbsp;
                    <Button variant="outline-secondary" size="sm" onClick={() => {
                        setIdEmpleadoVacaciones(row.pk_empleado)
                        handleShowHistorial()
                    }}>
                        Historial
                    </Button> */}
                </>
            )
        },
    ];




    return {
        listaAdmin, cargando, buscar, setBuscar, elementosFiltrados, columns,
        showForm, handleCloseForm, handleShowForm, showHistorial, handleCloseHistorial, handleShowHistorial
    }

}

